var map = {
	"./resources-abc": [
		"87ce",
		"live-stream76"
	],
	"./resources-abc.vue": [
		"87ce",
		"live-stream76"
	],
	"./resources-privatebrands": [
		"e9f2",
		"live-stream78"
	],
	"./resources-privatebrands.vue": [
		"e9f2",
		"live-stream78"
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "ec2d";
module.exports = webpackAsyncContext;